import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@emburse/ui-core';
import { isPhysicalCardIssuingEnabled } from '@Shared/helpers/validators';
import { CardType } from '@Shared/interfaces/CardsGatewayInterfaces';
const VIRTUAL_RADIO_ITEMS = [
    {
        label: 'Issue Virtual Card',
        value: CardType.Ghost
    },
    {
        label: 'Mail Plastic Card',
        value: CardType.Physical
    }
];
export const CardTypeFormBase = ({ linkedAccountId, capabilities, cardType, onChange, userProfile }) => {
    var _a;
    // TODO: Move these a level up
    const editMode = Boolean(linkedAccountId);
    const virtualCardForm = Boolean((_a = capabilities.issuing) === null || _a === void 0 ? void 0 : _a.virtual);
    const company = window.ORG;
    /**
     * Does not display if editing a card.
     *
     * Does not display if issuing virtual cards.
     *
     * If possible to issue both types of real cards, render the radio.
     *
     * If only possible to issue physical cards (or physical radio option is chosen), render shipping address form.
     */
    // cannot switch card type when updating
    if (editMode) {
        return null;
    }
    if (cardType === CardType.Virtual) {
        return null;
    }
    let canSelectCardType;
    if (virtualCardForm) {
        // If virtual card issuing is available, you must issue virtual cards only
        canSelectCardType = false;
    }
    else {
        // Otherwise, you can select type if ghost issuing and physical issuing are both enabled
        const canIssuePhysicalCards = isPhysicalCardIssuingEnabled(company, userProfile);
        canSelectCardType = capabilities.issuing.physical && canIssuePhysicalCards && capabilities.issuing.ghost;
    }
    return (_jsx(_Fragment, { children: canSelectCardType && (_jsx(RadioGroup, Object.assign({ name: "ghost", value: cardType, onChange: (event) => onChange({ cardType: event.target.value }), style: { display: 'inline-block', marginBottom: 16 } }, { children: VIRTUAL_RADIO_ITEMS.map((radioItem) => (_jsx(FormControlLabel, { value: radioItem.value, control: _jsx(Radio, {}), label: radioItem.label }, radioItem.value))) }))) }));
};
export const CardTypeForm = React.memo(CardTypeFormBase);
